<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.loadingDetailEdit" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="detail" :wrapper-col="{span:16}">
      <vxe-card>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="16">
            <a-form-model-item :label="$t('business.label.customer')" :label-col="{span:4}" :wrapper-col="{span:20}">
              <vxe-input v-model="detail.customer.name" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.wave')">
              <vxe-input v-model="detail.wave" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </vxe-card>
      <vxe-card :title="$t('business.label.reviewStatistics')">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
              <vxe-number-input v-model="detail.reviewStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
              <vxe-number-input v-model="detail.reviewStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
              <vxe-number-input v-model="detail.reviewStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </vxe-card>
      <vxe-card :title="$t('business.label.materialStatistics')">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
              <vxe-number-input v-model="detail.materialStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
              <vxe-number-input v-model="detail.materialStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
              <vxe-number-input v-model="detail.materialStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </vxe-card>
      <vxe-card :title="$t('business.label.coldStatistics')">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
              <vxe-number-input v-model="detail.coldStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
              <vxe-number-input v-model="detail.coldStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
              <vxe-number-input v-model="detail.coldStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </vxe-card>
      <vxe-card :title="$t('business.label.shelfStatistics')">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
              <vxe-number-input v-model="detail.shelfStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
              <vxe-number-input v-model="detail.shelfStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
              <vxe-number-input v-model="detail.shelfStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </vxe-card>
      <vxe-card :title="$t('business.label.unDeliveryStatistics')">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
              <vxe-number-input v-model="detail.unDeliveryStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
              <vxe-number-input v-model="detail.unDeliveryStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
              <vxe-number-input v-model="detail.unDeliveryStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </vxe-card>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { findOne, post } from '@/api/Api'
import api from '@/api'
import { LoadingDetail } from '@/api/dto/order/LoadingOrder'
import { BaseObject } from '@/api/dto/BaseObject'

export default {
  name: 'LoadingDetailEditor',
  data() {
    return {
      visible: false,
      loading: false,
      detail: new LoadingDetail()
    }
  },
  methods: {
    open(id) {
      this.visible = true
      this.fetch(id)
    },
    fetch(id) {
      this.loading = true
      findOne('loadingDetailFactory', { 'detail.id': id }).then(res => {
        if (res.success) {
          this.detail = new LoadingDetail(BaseObject.merge(res.result, 'detail'))
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      post(api.deliverySaveDetail, {}, this.detail.toJSONObject()).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('postSave')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>